import { Controller } from '@hotwired/stimulus'
import Handorgel from 'handorgel';

export default class extends Controller {
    handorgel = null

    connect() {
        this.handorgel = new Handorgel(this.element);

        const hash = window.location.hash;

        if (hash) {
            this.openFoldById(hash.substring(1));
        }
    }

    disconnect() {
        this.handorgel?.destroy();
    }

    openFoldById(foldId) {
        const header = this.element.querySelector('[data-fold-id="'+foldId+'"]');

        if (!header || !header.handorgelFold) {
            return;
        }

        if (header.handorgelFold.expanded) {
            header.handorgelFold.content.scrollIntoView({ block: 'center' });
        } else {
            this.handorgel.once('fold:opened', () => {
                header.handorgelFold.content.scrollIntoView({ block: 'center' });
            });

            header.handorgelFold.open(true);
        }
    }
}
